import React from 'react';
import ResourceWorkspace from '../../components/admin/ResourceWorkspace';
import OperationsPanel from '../../components/admin/OperationsPanel';

const tabs = [
  {
    "title": "Deposit transactions",
    "resource": "core/wallettransactions",
    "columns": [
      "id",
      "created",
      "user",
      "currency",
      "blockchain",
      "amount",
      "tx_amount",
      "state",
      "tx_hash"
    ]
  },
  {
    "title": "User wallets & blocks",
    "resource": "core/userwallet"
  },
  {
    "title": "Credited top-ups",
    "resource": "admin_rest/topups"
  },
  {
    "title": "Reversal history",
    "resource": "core/wallettransactionsrevert"
  },
  {
    "title": "KYT scoring",
    "resource": "cryptocoins/transactioninputscore"
  },
  {
    "title": "Fees & limits",
    "resource": "core/feesandlimits"
  }
];

export default function DepositsPage() {
  return <ResourceWorkspace title="Deposits & accumulation"  tabs={tabs}><OperationsPanel group="deposits" /></ResourceWorkspace>;
}
